import { render, staticRenderFns } from "./F2FAnswerChart.vue?vue&type=template&id=1198e47c"
import script from "./F2FAnswerChart.vue?vue&type=script&lang=js"
export * from "./F2FAnswerChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports